"use client";

import dynamic from 'next/dynamic';
import { Prompt } from "@/types/assessment.types";

// Dynamically import the assessment with no SSR to prevent hydration issues
const StepByStepAssessment = dynamic(
  () => import('./StepByStepAssessment'),
  { 
    ssr: false,
    loading: () => (
      <div className="flex flex-col gap-8 max-w-4xl mx-auto">
        <div className="animate-pulse">
          <div className="h-2 bg-gray-200 rounded-full mb-8"></div>
          <div className="space-y-4">
            <div className="h-8 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
        </div>
      </div>
    )
  }
);

type Props = {
  prompt: Prompt;
  assessmentType: string;
  flow?: any; // Keep as any for now to maintain compatibility
  ThankYouTemplate?: React.ComponentType<any>;
};

export default function AssessmentWrapper(props: Props) {
  return <StepByStepAssessment {...props} />;
}